import { Card, CardContent, Icon, style } from '@do/walrus';
import React from 'react';
import styled from 'styled-components';
import copy from '../copy';
import { LEARN_MORE_URL, TRY_IT_URL } from './constants';

const StyledCard = styled(Card)`
  margin-top: ${style.vars.space['3']};
`;

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
`;

const TextContainer = styled.div`
  margin-right: ${style.vars.space['3']};
`;

const StyledLink = styled.a.attrs({
  target: '_blank',
  rel: 'noopener noreferrer'
})`
  display: inline-block;
  font-weight: ${style.vars.fontWeight.bold};
  margin-top: ${style.vars.space['3']};
  margin-right: ${style.vars.space['3']};
`;

const PromoImage = styled.img.attrs({
  src: '/static/dbaas-mongo-nodejs-promo.png',
  alt: ''
})`
  width: 100px;
  height: 100px;
`;

export const NodeMongoBanner: React.FC = () => (
  <StyledCard>
    <CardContent>
      <FlexContainer>
        <TextContainer>
          <h6>{copy.nodeMongoBanner.new}</h6>

          {copy.nodeMongoBanner.description}

          <div>
            <StyledLink href={TRY_IT_URL}>
              {copy.nodeMongoBanner.tryIt} <Icon icon="arrow-right-long" />
            </StyledLink>
            <StyledLink href={LEARN_MORE_URL}>
              {copy.nodeMongoBanner.learnMore} <Icon icon="arrow-right-long" />
            </StyledLink>
          </div>
        </TextContainer>

        <PromoImage />
      </FlexContainer>
    </CardContent>
  </StyledCard>
);
